<template>
  <div :class="['package-box', `package-${packType}`]">
    <div :class="['title', `title-${packType}`]">{{title}}</div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    packType: {
      type: String,
      default: 'hk'
    },
    title: {
      type: String,
      default: '港股'
    }
  },
  setup() {
  }
}
</script>
<style scoped lang="stylus">
.package-box
  padding-top: 58px
  margin 0 auto
  margin-bottom: 48px
  .title
    position relative
    margin-bottom: 44px
    font-size: 48px;
    font-weight bold
    color: #000
    line-height: 66px;
    text-align: left
    padding-left 46px
    display: inline-block
    z-index 0
    &::after
      content: ''
      position: absolute
      left 10px
      right -32px
      bottom: 0
      transform: translateY(-4px)
      display: inline-block
      // width: 168px;
      height: 22px;
      border-radius: 11px
      opacity: 0.5;
      z-index -1
    &.title-hk
      &::after
        background: linear-gradient(-270deg, rgba(255, 255, 255, 0) 0%, #FF5001 100%);
    &.title-us
      &::after
        background: linear-gradient(-270deg, rgba(255, 255, 255, 0) 0%, #2E94FF 100%);
    &.title-A
      &::after
        background: linear-gradient(-270deg, rgba(255, 255, 255, 0) 0%, #FF0101 100%);
</style>
